import cn from 'classnames';
import { AnchorLogo } from 'seagull/icons';
import styles from "./GenericError.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function GenericError(props) {
  const {
    testid,
    fullPage
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.root, {
      [styles.fullPage]: fullPage
    }),
    "data-testid": testid,
    children: [/*#__PURE__*/_jsx(AnchorLogo, {
      className: styles.logo
    }), /*#__PURE__*/_jsx("div", {
      className: styles.text,
      children: "Something went wrong... Please try again later"
    })]
  });
}